import 'moment/locale/es'
import React, { useEffect, useRef, useState } from 'react'
import { useQuery } from '@apollo/client'
import moment from 'moment'
import ContentHeader from '../../../Layout/ContentHeader'
import LayoutTable from '../../../Global/LayoutTable'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import ModalContent from '../../../Global/ModalContent'
import ModalUserAppInfo from './components/ModalUserAppInfo'
import { GET_ALL_USER_APP } from '../../../../graphql/Catalog/UsersApp/userApp'
import { GET_ALL_REPORTS } from '../../../../graphql/Catalog/Reports/reports'
moment.locale('es')

const pagePaginationDefault = {
  searchQuery: null,
  limit: 10,
  offset: 0,
  filters: {
    suspended: null,
  },
}
const modalDefault = {
  modalId: false,
  size: 'extra',
  title: '',
  content: null,
}
const optionsSuspended = [
  { label: 'Suspendidos', value: true },
  { label: 'Activos', value: false },
]

export const UsersApp = () => {
  //REFS
  const refModal = useRef(null)

  //STATES:
  const [pagePagination, setPagePagination] = useState(pagePaginationDefault)
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])
  const [closeModal, setCloseModal] = useState(false)
  const [modal, setModal] = useState(modalDefault)

  //QUERIES:
  const { loading, error, data, refetch } = useQuery(GET_ALL_USER_APP, {
    variables: { ...pagePagination },
    fetchPolicy: 'no-cache',
    refetchQueries: [
      { query: GET_ALL_REPORTS, variables: pagePaginationDefault },
    ],
  })

  //FUNCTIONS
  const handleShowInfoUserApp = async (item) => {
    setModal({
      id: 1,
      modalId: `modal${1}`,
      size: 'extra',
      title: `Usuario de app`,
      content: (
        <ModalUserAppInfo
          data={item}
          refetchOrigin={refetch}
          setCloseModal={setCloseModal}
        />
      ),
    })
  }

  const handleFilters = (e, field) => {
    let filterSelected = e.target.value

    if (field == 'suspended') {
      if (filterSelected === 'true') filterSelected = true
      else if (filterSelected === 'false') filterSelected = false
      else filterSelected = null
    }

    setPagePagination({
      ...pagePagination,
      filters: {
        ...pagePagination.filters,
        [field]: filterSelected,
      },
    })
  }

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error) {
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      }

      let list = []
      data.getAllUserApp.rows.map((item) => {
        let objSuspended = {
          txt: 'Suspender usuario',
          // color: 'btn-migrates',
          icon: 'fas fa-user-slash',
        }

        if (item?.suspended) {
          objSuspended = {
            txt: 'Reactivar usuario',
            // color: 'btn btn-migrates btn-migrates-cover btn-sm mb-1',
            icon: 'fas fa-user-check',
          }
        }

        return list.push({
          id: item.id,
          Nombre: item?.name,
          Email: item?.email,
          Telefono: item?.phone,
          Direccion: item?.address,
          acciones: (
            <button
              className={`btn btn-migrates btn-migrates-cover btn-sm mb-1`}
              onClick={() => handleShowInfoUserApp(item)}
              title={objSuspended.txt}
            >
              <i class={objSuspended.icon}></i>
            </button>
          ),
        })
      })
      setDataToTable(list)
      setTotal(data.getAllUserApp.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  useEffect(() => {
    if (modal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
    }
  }, [modal])

  useEffect(() => {
    if (closeModal) {
      document.getElementById(`spanModal${modal.modalId}`).click()
      setTimeout(() => {
        setModal(modalDefault)
        setCloseModal(false)
      }, 400)
    }
  }, [closeModal])

  return (
    <>
      <ContentHeader
        title="Usuarios de App"
        breadcrumb=""
        windowTitle="Usuarios de App"
      />

      <div className="reports reports-layout">
        <LayoutTable
          title="Lista"
          showCardHeader={false}
          classCardBody="card-body mt-3"
          subHeaderComponentClassName="row mb-3"
          hideId
          hideActions
          hideAddNew
          data={dataToTable}
          requery={GET_ALL_USER_APP}
          exportImportButton={false}
          totalCount={total}
          pagePagination={pagePagination}
          setPagePagination={setPagePagination}
          loadingData={loading}
          FilterBarPlaceholder="Buscar por nombre o email"
          filterBarValue={pagePagination.searchQuery}
          filter
          filterOnChange={(e) => handleFilters(e, 'suspended')}
          filterOptions={optionsSuspended.map((item) => (
            <option
              value={item.value}
              key={item.value}
              selected={pagePagination.filters.suspended === item.value}
            >
              {item.label}
            </option>
          ))}
          filterDefaultOptionText="Todos los estatus"
        />
      </div>

      <span
        id={`spanModal${modal.modalId}`}
        className="invisible"
        data-toggle="modal"
        data-target={`#${modal.modalId}`}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
        ref={refModal}
      />

      <ModalContent
        idModal={modal.modalId}
        title={modal.title}
        size={modal.size}
        onClose={() => setModal(modalDefault)}
        content={modal.content}
      />
    </>
  )
}

export default UsersApp
